import { useLogoLongPress } from '@/hooks/useLogoLongPress'
import { useKioskStore } from '@/stores/kiosk-store'

export default function KioskLogo({ className }: { className: string }) {
  const remoteConfig = useKioskStore((state) => state.remoteConfig)
  const setAdminOpen = useKioskStore((state) => state.setAdminOpen)
  const locale = useKioskStore((state) => state.locale)
  const events = useLogoLongPress(() => setAdminOpen(true))
  return (
    <button type="button" {...events} className={`${className} touch-none`} aria-label={locale === 'sv' ? 'Håll in i 5 sekunder för admin' : 'Hold for 5 seconds to open admin'}>
      {remoteConfig?.logoUrl ? (
        <img src={remoteConfig.logoUrl} alt={remoteConfig.appName ?? ''} className="w-full h-full object-contain pointer-events-none" />
      ) : (
        <span className="text-kiosk-accent font-bold text-4xl">{remoteConfig?.appName?.slice(0, 1) || 'K'}</span>
      )}
    </button>
  )
}
